import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { brand } from '../../theme';

const StyledButton = styled(Button)(({ theme, variant }) => ({
  ...(variant === 'contained' && {
    backgroundColor: brand.navy,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: brand.navyHover,
      boxShadow: '0 8px 24px rgba(16, 36, 62, 0.18)',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    },
  }),
  ...(variant === 'outlined' && {
    borderColor: brand.navy,
    color: brand.navy,
    borderWidth: 1.5,
    '&:hover': {
      borderColor: brand.navyHover,
      borderWidth: 1.5,
      backgroundColor: 'rgba(16, 36, 62, 0.04)',
    },
  }),
  ...(variant === 'text' && {
    color: brand.navy,
    '&:hover': {
      backgroundColor: 'rgba(16, 36, 62, 0.04)',
    },
  }),
}));

export default StyledButton;
